import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import { SLOT_ROUTE } from '../../../../common/utils/constants'
import { addNotification } from '../../../../store/slices/notificationSlice'
import { v4 } from 'uuid'
import { Group, NotificationTypes } from '../../../../common/types/enums'
import { getApi } from '../../../../api/api'
import { SlotItemInterface } from '../../../../common/types/interfaces'
import { RootState } from '../../../../store/store'
import { selectSlotItem, selectSlotList } from '../../../../store/slices/slotListSlice'
import { selectCurrentUser } from '../../../../store/slices/currentUserSlice'

export const useSlotItem = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [api] = useState(getApi())
  const [item, setItem] = useState<SlotItemInterface>()
  const currentUser = useSelector(selectCurrentUser)
  const slotList = useSelector(selectSlotList)

  const itemState = useSelector((state: RootState) => selectSlotItem(state, Number(id)))



  const getItem = useCallback(async () => {
    try {
      let result: SlotItemInterface
      if (currentUser) {
        result = await api.getSlot(Number(id))
      } else {
        result = await api.getAdSlot(Number(id))
      }
      if (result) {
        setItem(result)
        window.scrollTo(0, 0)
        return
      }
      dispatch(
        addNotification({
          id: v4(),
          type: NotificationTypes.ERROR,
          text: 'Слот не найден.',
        }),
      )
      navigate(SLOT_ROUTE)
    } catch (error) {
      dispatch(
        addNotification({
          id: v4(),
          type: NotificationTypes.ERROR,
          text: 'Слот не найден.',
        }),
      )
      navigate(SLOT_ROUTE)
    }
  }, [api, dispatch, id, navigate, currentUser])

  const addView = useCallback(
    async (el: SlotItemInterface) => {
      try {
        if (currentUser && currentUser.id && el.id && el.userId !== currentUser.id) {
          await api.addView({ el_id: el.id }, Group.SLOT)
          await getItem()
        }
      } catch (error) {}
    },
    [api, currentUser, getItem],
  )

  const toggleSelected = useCallback(
    async (item: SlotItemInterface) => {
      try {
        const id = item.selected?.find((el: any) => el.user_id === currentUser?.id)?.id
        if (item && id) {
          await api.deleteSelected({ id }, Group.SLOT)
        } else if (item.id) {
          await api.addSelected({ el_id: item.id }, Group.SLOT)
        }
        await getItem()
      } catch (error) {}
    },
    [api, currentUser?.id, getItem],
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    // if (itemState) {
    //   setItem(itemState)
    //   return
    // }
    getItem()
  }, [api, itemState])

  useEffect(() => {
    if (itemState) addView(itemState)
  }, [itemState])

  useEffect(() => {
    if (item?.id && !slotList.data.find((el) => el.id === item?.id)) navigate(-1)
  }, [slotList, item?.id])

  return { item, toggleSelected }
}
